<template>
  <div class="c-modal" v-if="pageVisible">
    <div class="mask">
      <Rights
        v-if="rightType == 'generate' || rightType == 'video' || rightType == 'invite'"
        :rightType="rightType"
        :create_type="props.create_type"
        :source="props.source"
      />
      <div class="content">
        <div class="mobile-title">
          <div class="left">登录</div>
          <img @click="closePage" src="@/assets/img/mobile/icon-close.png" alt="" />
        </div>
        <div class="close-btn" @click="closePage">
          <img src="@/assets/img/ic_close.png" alt="" />
        </div>
        <div class="flex-center bg-img">
          <div class="login-module-main login-in-main">
            <div class="login-img-box">登录</div>
            <div class="login-in-main-content">
              <LoginCn @submit="submit" />
            </div>
            <div class="recover" @click="recover">账号找回&迁移</div>
            <div class="terms">
              <div
                class="checkbox"
                :class="{ active: termCheckbox }"
                @click="changeRadioValue"
              ></div>
              <div class="text-box">
                请阅读并同意<span @click="goTerms" class="a-link btn pointer"
                  >《Mureka用户协议》</span
                >
                <span @click="goPrivacy" class="a-link btn pointer">《Mureka隐私政策》</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  onMounted,
  readonly,
  reactive,
  watch,
  defineExpose,
  triggerRef,
  getCurrentInstance,
} from "vue";
import message from "@/components/functionCallComponent/message/message.js";
import ShowActionDialog from "@/components/functionCallComponent/action/action.js";
import apiUser from "@/api/api/apiUser.js";
import { useRouter } from "vue-router";
import useUserDataStore from "@/store/userDataStore";
import { funComponentList } from "@/components/functionComp/index";
import Btn from "@/components/basic/button/Button.vue";
import { getParameterByName } from "@/utils/tools.js";
import LoginCn from "@/components/login/LoginFormCn.vue";
import Rights from "./rights.vue";
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
import { getUseSource } from "@/api/net/config.js";
import globalConfig from "@/config/config.js";

const globalProperties = getCurrentInstance()?.appContext.config.globalProperties;

const { $$t } = globalProperties?.$i18n;

//自定义函数组件无法使用全局组件，需要单独引入
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  okText: {
    type: String,
    default: "确定",
  },
  handleOk: {
    type: Function, //成功回调
    default: null,
  },
  remove: {
    type: Function, //传入移除节点方法,这里是createApp中的方法
    default: null,
  },
  content: {
    type: String,
    default: "自定义全局函数组件......",
  },
  rightType: {
    type: String, // 'generate' | 'login' | undefined, // 显示权益的类型
    default: "login",
  },
  create_type: {
    type: String,
    default: "2",
  },
  source: {
    type: String,
    default: "other",
  },
});

const pageVisible = ref(false);
pageVisible.value = props.visible;
// 监听显示的消失，需要移除dom
watch(
  () => pageVisible.value,
  (val) => {
    !val && props.remove();
  }
);

const recover = () => {
  window.open("https://platform.mureka.ai/recoveraccount", "_blank");
};

const goTerms = () => {
  window.open(
    globalConfig.appname == "MurekaCn"
      ? import.meta.env.VITE_API_URL + "/static/terms-cn-20250829.pdf"
      : import.meta.env.VITE_API_URL + "/static/terms-20250709.pdf",
    "_blank"
  );
};

const goPrivacy = () => {
  window.open(
    globalConfig.appname == "MurekaCn"
      ? import.meta.env.VITE_API_URL + "/static/privacy.pdf"
      : import.meta.env.VITE_API_URL + "/static/privacy-20250709.pdf",
    "_blank"
  );
};

const termCheckbox = ref(false);

const userDataStore = useUserDataStore();

const closePage = () => {
  pageVisible.value = false;
  firebaseUtils.logClickEvent(
    props.rightType === "generate" ? "close_new_user_login" : "close_login",
    {
      create_type: props.create_type,
      page_route: window.location.pathname,
      source: props.source,
    }
  );
};

const changeRadioValue = () => {
  termCheckbox.value = !termCheckbox.value;
};

const submit = async ({ email, password }) => {
  firebaseUtils.logClickEvent(props.rightType === "generate" ? "newuser_login" : "login", {
    create_type: props.create_type,
    loginIsAgree: termCheckbox.value ? "1" : "0",
    source: props.source,
    page_route: window.location.pathname,
  });
  if (!termCheckbox.value) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "请阅读并同意用户协议与隐私政策",
    });
    return;
  }
  const { data, code, msg, block_end_time } = await apiUser.userLogin({
    token: email,
    mode: "otp_message",
    extra_token: password,
  });
  console.log("submit==>", data, code, msg);
  if (code == 200) {
    if (data?.is_new) {
      invite();
    }
    updateAuthData(data);
    typeof props.handleOk === "function" && props.handleOk(true);
    pageVisible.value = false;
  } else if (code == 3002 || code == 3003) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "发送过于频繁，请稍后再试",
    });
  } else if (code == 3004) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "输入的验证码有误，请重试",
    });
  } else if (code == 3005) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "手机号格式不正确",
    });
  } else if (code == 3006) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "手机号格式不正确",
    });
  } else if (code == 2110) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "您的账号已注销",
    });
  } else if (code == 9008) {
    message.error({
      maskClosable: true,
      position: "top",
      content: $$t("library.too_frequently"),
    });
  } else if (code == 1019) {
    if (block_end_time == 5000000000) {
      showError("该账户已被永久封禁，无法登录。如有疑问，请联系客服。");
    } else {
      const blockEndDate = new Date(block_end_time * 1000);
      const formattedDate = `${blockEndDate.getFullYear()}年${
        blockEndDate.getMonth() + 1
      }月${blockEndDate.getDate()}日`;
      showError(`该账户已被封禁至${formattedDate}，暂时无法登录。如有疑问，请联系客服。`);
    }
  } else {
    console.log("code", code);
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    });
  }
};

const showError = (content) => {
  message.error({
    maskClosable: true,
    position: "top",
    content,
  });
};

const invite = () => {
  const invite = localStorage.getItem("invite_code") ?? "";
  console.log("inviteinvite", invite);
  if (invite) {
    userDataStore.inviteCodePoint(invite);
  }
};

const updateAuthData = (_data) => {
  userDataStore.upDataAuthData(_data.auth);
  userDataStore.updateLoginStatus(true);
};
</script>

<style lang="scss" scoped>
.c-modal {
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.5);
  .mask {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 48px;
  }
  .content {
    position: relative;
    left: 0;
    top: 0;
    transform: none;
    background: linear-gradient(130deg, #1a3c8d 0%, #695bc5 47%, #3a1b6f 100%);
    overflow: hidden;
    border-radius: 20px;
    // width: 300px !important;
    .login-module-main {
      width: 100%;
    }
    .recover {
      padding-top: 16px;
      text-align: center;
      text-decoration: underline;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
    }
    .terms {
      padding-top: 23px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      a {
        text-decoration: none;
        color: #94adff;
      }
      .checkbox {
        width: 20px;
        height: 20px;
        background-image: url("@/assets/img/login/radio-empty.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 8px;
        &.active {
          background-image: url("@/assets/img/login/radio-full.png");
        }
      }
      .text-box {
        flex: 1;
        text-align: left;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .mask {
      flex-direction: column-reverse;
      align-items: center;
      justify-content: center;
      gap: 24px;
      .close-btn {
        display: none;
      }
    }
    .content {
      box-sizing: content-box;
      margin: 0;
      padding: 28px;
      width: 300px;
    }
  }
}
</style>
